import * as axios from 'axios';
import * as React from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import i18n from '../i18n';
import { AppContainerParams } from './config';
import { configureStore, InitialState } from '../redux/configure-store';
import { buildServerApi } from '../services/server-api';
import fedopsLogger from '../services/fedops';
import App from '../components/App';

wixAxiosConfig(axios, {
  baseURL: '/',
});

export default class AppContainer extends React.Component<AppContainerParams> {
  i18n = i18n({
    locale: this.props.locale,
    baseUrl: this.props.config.topology.staticsUrl,
  });
  store;

  constructor(props) {
    super(props);
    props.notifyViewStartLoading();
    const {
      debug,
      locale,
      config: { topology },
      msid,
    } = props;
    const services = {
      serverApi: buildServerApi(msid)
    };
    const initialState: InitialState = {
      debug,
      locale,
      topology,
      msid,
    };
    this.store = configureStore(initialState, services);
  }

  notifyViewFinishedLoading = () => {
    fedopsLogger.appLoaded();
    this.props.notifyViewFinishedLoading();
  }

  render() {
    const { basename, experimentScope } = this.props;
    return (
      <ExperimentsProvider options={{ scope: experimentScope }}>
        <Provider store={this.store}>
          <I18nextProvider i18n={this.i18n}>
              <App basename={basename} notifyViewFinishedLoading={this.notifyViewFinishedLoading}/>
          </I18nextProvider>
        </Provider>
      </ExperimentsProvider>
    );
  }
}
